import { Article } from '../../../shared/models/article';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaginationService} from '../../../shared/services/pagination.service';
import { UserService } from 'src/app/shared/services/user.service';
import { CustomerService } from 'src/app/shared/services/customer.service';

@Component({
    selector: 'app-special-products',
    templateUrl: './special-products.component.html',
    styleUrls: ['./special-products.component.scss'],
    standalone: false
})
export class SpecialProductsComponent implements OnInit {
  counter: number;
  @Input() products: Article[];
  @Input() cantpages: number;
  @Input() page: number;
  @Input() loading: boolean;

  @Output() previous: EventEmitter<any> = new EventEmitter();
  @Output() nextPage: EventEmitter<any> = new EventEmitter();
  // TODO: reactivar mayorista/minorista — cambiar a false y restaurar loadIsWholesaler
  isWholesaler: boolean = true;

  constructor(private paginateService: PaginationService, private userService: UserService, private customerService: CustomerService) {
  }

  paginate: any = {};

  ngOnInit() {
    this.counter = 1;
    this.loadIsWholesaler();
  }

  increment = () => this.counter++;

  decrement() {
    if (this.counter > 1) {
      this.counter--;
    }
  }

  lastPage = (): boolean => {
    const p = this.page + 1;
    return p > this.cantpages;
  }

  prev = () => this.previous.emit(null);
  next = () => this.nextPage.emit(null);

  // TODO: reactivar mayorista/minorista — descomentar este método y llamarlo en ngOnInit
  // loadIsWholesaler(): void {
  //   const customerId = this.userService.getIdentity()?.id || null;
  //   if (customerId) {
  //     this.customerService.isWholesaler(customerId).subscribe((res: boolean) => {
  //       this.isWholesaler = res;
  //     });
  //   }
  // }
  loadIsWholesaler(): void { /* desactivado temporalmente */ }
}
